import tonStyles from './../ton.json'

export default {
  backgroundColor: tonStyles.colors.PrimaryWhite
}
